import React, {useMemo} from 'react';
import {DataProvider, useDataConfig} from '@sail/data';
import type {DataConfig, Fetch} from '@sail/data';

export const FundingSessionDataProvider = ({
  sharedCacheId,
  children,
}: {
  sharedCacheId: symbol;
  children: React.ReactNode;
}) => {
  const parentConfig = useDataConfig();
  const config = useMemo<DataConfig>(() => {
    const fundingSessionFetch: Fetch = (url, options, interceptFetch) => {
      const headers = new Headers(options?.headers);
      if (/^\/graphql(?:[/?]|$)/.test(url)) {
        // data-v2 attaches Authorization from the query token.
        // Let the UAT's compartment determine mode, including legacy test mode.
        headers.delete('Stripe-Livemode');
      }

      const parentFetch: Fetch =
        parentConfig.fetch ??
        ((requestUrl, requestOptions) => fetch(requestUrl, requestOptions));
      return parentFetch(
        url,
        {...options, headers: Object.fromEntries(headers.entries())},
        interceptFetch,
      );
    };

    return {
      ...parentConfig,
      fetch: fundingSessionFetch,
      graphql: {
        ...parentConfig.graphql,
        schemas: parentConfig.graphql?.schemas ?? {},
        sharedCacheId,
      },
    };
  }, [parentConfig, sharedCacheId]);

  return <DataProvider config={config}>{children}</DataProvider>;
};
